import request from '@/utils/requestJiuRui'

/**
 * 获取教材完整图谱
 * @param {Object} data
 * @param {String} data.courseCode 教材文稿编码
 */
export function getBookGraphs(data) {
  return request({
      url: '/gw/open/textbooksNew/getCourseGraphByAll',
      method: 'post',
      data
  })
}

/**
 * 获取教材内内容对应标的图谱
 * @param {Object} data
 * @param {String} data.courseCode 教材文稿编码
 * @param {String} data.text 教材内容, 一般是整个章节活页的所有文本组件内容
 */
export function getContentIndexedGraphs(data) {
  return request({
      url: '/gw/open/textbooksNew/dataIndexing',
      method: 'post',
      data
  })
}

/**
 * 图谱关系查询
 * @param {Object} data
 * @param {String} data.courseCode 教材文稿编码
 * @param {String} data.nodeId 节点id
 */
export function getGraphNodeRelations(data) {
  return request({
      url: '/gw/open/textbooksNew/searchGraphByNodeId',
      method: 'post',
      data
  })
}

/**
 * 节点详情查询
 * @param {Object} data
 * @param {String} data.courseCode 教材文稿编码
 * @param {String} data.nodeId 节点id
 */
export function getGraphNodeDetail(data) {
  return request({
      url: '/gw/open/textbooksNew/searchNodeById',
      method: 'post',
      data
  })
}